import { Injectable, inject } from '@angular/core';
import { RolesService, RoleWithPermissions } from '../../../permission/services/roles.service';
import { UserInterface } from '../../interfaces/user.interface';
import { PermissionCollection } from '../../permissions/permission.collection';
import { UserRole } from '@core/enums/user-role.enum';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  private rolesService = inject(RolesService);

  public setRolesAndPermissions(user: UserInterface): void {
    const rolesWithPermissions: RoleWithPermissions[] = [];

    const userRolePermissions = this.getUserRolePermissions(user);
    if (userRolePermissions) {
      rolesWithPermissions.push(userRolePermissions);
    }

    this.rolesService.setRolesWithPermissions(rolesWithPermissions);
  }

  private getUserRolePermissions(user: UserInterface): RoleWithPermissions | undefined {
    return this.userRolePermissions.find((roleWithPermissions) => roleWithPermissions.name === user.userRole);
  }

  private get userRolePermissions(): RoleWithPermissions[] {
    return [
      {
        name: UserRole.SuperAdmin,
        permissions: [
          PermissionCollection.saveProjectConfiguration,
          PermissionCollection.editTeamMember,
          PermissionCollection.changeProjectEpc,
          PermissionCollection.canSeeRecenter,
          PermissionCollection.shipmentListViewFlagAction,
          PermissionCollection.deliveryVsEpcReport,
          PermissionCollection.deliveryVsMsaReport,
          PermissionCollection.deliveryVsMsaAndEpcReport,
          PermissionCollection.progressTrackingReport,
          PermissionCollection.inventoryTrackingReport,
          PermissionCollection.navigateToProjectSetup,
          PermissionCollection.editDeleteDronOrtho,
          PermissionCollection.editDeleteDronePano,
          PermissionCollection.canEditProject,
          PermissionCollection.canAddEditRovers,
          PermissionCollection.canEditSchedule,
          PermissionCollection.canAddNewConstructionProject,
          PermissionCollection.canAccessEditProject,
          PermissionCollection.canVerifyCircuitStatus,
        ],
      },
      {
        name: UserRole.CompanyAdmin,
        permissions: [
          PermissionCollection.saveProjectConfiguration,
          PermissionCollection.editTeamMember,
          PermissionCollection.changeProjectEpc,
          PermissionCollection.editDeleteDronePano,
        ],
      },
      { name: UserRole.CompanyUser, permissions: [] },
    ];
  }
}
